import React from 'react';
import { red, green, yellow, amber, purple } from '@mui/material/colors';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: red['A200'],
        },
        secondary: {
            main: green['A400'],
        },
        highlight: {
            green: green['A100'],
            yellow: yellow['100'],
            red: red['100'],
        },
        tint: {
            success: green[700],
            fail: red[700],
        },
        warning: {
            main: yellow[700],
        },
        banner: {
            info: amber[200],
        },
        exportTag: {
            free: yellow['A700'],
            test: purple['A100'],
        },
        background: {
            default: '#202124',
            paper: '#313235',
            darker1: '#18181C',
            darker2: '#121414',
        },
    },
    shape: {
        borderRadius: 6,
    },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '13px',
                },
            },
        },
        MuiButton: {
            variants: [
                {
                    props: { variant: 'text' },
                    style: {
                        color: 'white',
                        '&:hover': {
                            textDecoration: 'none !important',
                            backgroundColor: 'rgba(255, 255, 255, 0.08)',
                        },
                    },
                },
            ],
            styleOverrides: {
                outlined: {
                    background: 'rgba(0, 0, 0, 0.2)',
                },
                outlinedInherit:{
                    border: '1px solid rgba(255, 255, 255, 0.23)',
                    '&:hover': {
                      textDecoration: "none",
                      backgroundColor: " rgba(255, 255, 255, 0.08)"
                    }
                },
                containedPrimary: {
                    color: '#fff',
                    backgroundColor: red[700],
                    '&:hover': {
                        backgroundColor: '#932020',
                    },
                },
                containedSecondary: {
                    color: '#212121',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                },
                root: {
                    overflow: 'hidden',
                    backgroundImage: 'none',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    '&:hover': {
                        border: '1px solid rgba(255, 255, 255, 0.5)',
                    },
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    '&.MuiDrawer-paperAnchorLeft': {
                        width: 57,
                        transition: 'width 0.3s ease-in-out',
                    },
                    '&.MuiDrawer-paperAnchorLeft.MuiDrawer-paperOpen': {
                        width: 200,
                    },
                },
            },
        },
    },
});


export function MuiThemeProvider({ children }) {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default theme;